import PropTypes from 'prop-types';

export const sensorPropType = PropTypes.shape({
  type: PropTypes.string,
  identifier: PropTypes.string,
  id: PropTypes.number,
});
